import BaseAlgoliaSearch, { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { SearchSettings } from '@module/Algolia/resources/js/search/types';
import { transformProduct, transformStore } from './transformers';
import { transformArticle } from '@module/Algolia/resources/js/search/transformers';

let instance: AlgoliaSearch | null = null;

export default class AlgoliaSearch extends BaseAlgoliaSearch {
  static getInstance(): AlgoliaSearch {
    if (!instance) {
      instance = new AlgoliaSearch();
    }

    return instance;
  }

  protected getMainSearchSettings(): SearchSettings[] {
    return [...super.getMainSearchSettings(), this.getServicesSettings()];
  }

  protected getProductsSettings(): SearchSettings {
    return {
      ...super.getProductsSettings(),
      hitsPerPage: 24,
      transformer: transformProduct,
    };
  }

  protected getStoresSettings(): SearchSettings {
    return {
      ...super.getStoresSettings(),
      transformer: transformStore,
    };
  }

  isAnalyticsEnabled(): boolean {
    return AlgoliaSearch.isEnabled();
  }

  async loadEmptyState(hitsPerTypeOptions = {}) {
    const hitsPerType = {
      products: 4,
      collections: 7,
      suggestions: 5,
      ...hitsPerTypeOptions,
    };

    const settings: SearchSettings[] = [
      {
        ...this.getProductsSettings(),
        withFacets: false,
        stickyFacets: false,
        hitsPerPage: hitsPerType.products,
      },
      {
        name: 'collections',
        type: 'search',
        indexName: IndexNames.Collections,
        transformer: transformArticle,
        hitsPerPage: hitsPerType.collections,
      },
      {
        ...this.getSuggestionsSettings(),
        hitsPerPage: hitsPerType.suggestions,
      },
    ];

    const data = await this.performSearch('', {
      settings,
      ruleContexts: ['empty-state'],
    });

    if (data.type === 'aggregated') {
      return {
        products: data.results.products.data,
        collections: data.results.collections.data,
        suggestions: data.results.suggestions.data,
      };
    }

    return {
      products: [],
      collections: [],
      suggestions: [],
    };
  }
}

export const algoliaSearch = AlgoliaSearch.getInstance();
